export default __webpack_public_path__ + "static/media/20.f5564c99.webp";